import { OtpType } from '@shopee-user/otp-hook-tob';
import { BiometricType } from '@tob/shared/biometrics';

export enum TrackingDataFieldTypeLoginMethod {
  Password = 'password',
  Phone = 'phone',
  Email = 'email',
  ReloginBiometric = 'biometric',
  ReloginPhone = 'phone_relogin',
  ReloginPassword = 'password_relogin',
  ThirdPartyShopee = 'third_party_shopee',
  ThirdPartyGoogle = 'third_party_google',
  ThirdPartyFacebook = 'third_party_facebook',
  ThirdPartyApple = 'third_party_apple',
}

export enum TrackingDataFieldTypeSignupMethod {
  Phone = 'phone',
  Email = 'email',
}

export enum TrackingDataFieldTypeAccountType {
  OneCredential = 'one_credential',
  TobAccount = 'tob_account',
}

export type TrackingDataSignupProps = {
  method?: TrackingDataFieldTypeSignupMethod;
  accountType?: TrackingDataFieldTypeAccountType;
  otpType?: OtpType;
};

export type TrackingDataFieldSignup = {
  method?: TrackingDataFieldTypeSignupMethod;
  account_type?: TrackingDataFieldTypeAccountType;
  phone_verification_channel?: string;
};

export type TrackingDataLoginProps = {
  loginMethod: TrackingDataFieldTypeLoginMethod;
  accountType?: TrackingDataFieldTypeAccountType;
  biometricType?: BiometricType;
  otpType?: OtpType;
};

export type TrackingDataFieldLogin = {
  login_method: TrackingDataFieldTypeLoginMethod;
  account_type?: TrackingDataFieldTypeAccountType;
  biometrics_type?: string;
  phone_verification_channel?: string;
};
